import {
    useState,
    useMemo,
    useEffect,
} from 'react';
import {
    Container,
    BoxSelect,
    BtnSearch,
    Content,
    Title
} from './styled';
import { ChartGroups } from './ChartGroups';
import { DatePicker, InputList } from '../../../../components';
import { IoIosSearch } from 'react-icons/io';
import moment from 'moment';
import { apiAdmin } from '../../../../service/api';
import { TfiTimer } from "react-icons/tfi";


export function ServiceGroupsTimeWait() {


    const [parameters, setParameters] = useState({
        startDate: moment().subtract(6, 'months').format('YYYY-MM-DD'),
        finishDate: moment().format('YYYY-MM-DD'),
        visionType: {
            id: 0,
            name: 'Total - Mensal',
            value: 'M',
        }
    });
    const [dataGroups, setDataGroups] = useState([]);
    const [loading, setLoading] = useState(false);

    const objKey = (refKey) => {
        const keys = {
            'M': 'mes_extenso',
            'W': 'semana',
            'D': 'dia'
        }
        return keys[refKey]
    }
    const searchGroups = async (parameters) => {
        const dt_ini = moment(parameters.startDate).format('DD/MM/yyyy');
        const dt_fim = moment(parameters.finishDate).format('DD/MM/yyyy');
        const tipo_visao = parameters.visionType.value;
        try {
            setLoading(true);
            setDataGroups([]);
            const { data } = await apiAdmin.post(`/tempo-de-espera-grupo?dt_ini=${dt_ini}&dt_fim=${dt_fim}&tipo_visao=${tipo_visao}`)
            setDataGroups(data);
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        searchGroups(parameters);
    }, [])
    useEffect(() => {
        setDataGroups([]);
    }, [parameters])

    return (
        <Container>
            <BoxSelect>
                <div className='box--'>
                    <div className='line-'>
                        <DatePicker
                            className="date"
                            value={parameters.startDate}
                            onChange={(value) => setParameters((prev) => ({
                                ...prev,
                                startDate: value
                            }))}
                        />
                        <span> - </span>
                        <DatePicker
                            className="date"
                            value={parameters.finishDate}
                            onChange={(value) => setParameters((prev) => ({
                                ...prev,
                                finishDate: value
                            }))}
                        />
                    </div>
                    <div className='line-'>
                        <div className='list-'>
                            <InputList
                                options={[
                                    {
                                        id: 0,
                                        name: 'Total - Mensal',
                                        value: 'M',
                                    },
                                    {
                                        id: 1,
                                        name: 'Total - Semanal',
                                        value: 'W',
                                    }, {
                                        id: 2,
                                        name: 'Total - Diário',
                                        value: 'D',
                                    }
                                ]}
                                value={parameters.visionType?.name}
                                onChange={(value) => setParameters((prev) => ({
                                    ...prev,
                                    visionType: value
                                }))}
                                toView={'name'}
                            />
                        </div>
                        <BtnSearch
                            disabled={loading ? 1 : 0}
                            onClick={() => {
                                searchGroups(parameters);
                            }}
                        >
                            {loading
                                ? <span className='loader' />
                                : <IoIosSearch />
                            }
                        </BtnSearch>
                    </div>
                </div>
            </BoxSelect>
            <Content>
                <Title>
                    <span>
                        <TfiTimer fontSize={'2rem'} />
                    </span>
                    <div>
                        {`Tempo de espera por setores`}
                    </div>
                </Title>
                {(dataGroups.length > 0) &&
                    (<ChartGroups
                        groups={dataGroups}
                        objKey={objKey(parameters.visionType.value)}
                    />)
                }
            </Content>
        </Container >
    );
}
